angular
  .module('surfsightApp.controllers')
  .controller('manageOrganizationCtrl', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$rootScope',
    '$state',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $rootScope,
      $state
    ) {
      $scope.organizationId = $rootScope.currentUserOrganization.id
      $translate = $filter('translate')
      $scope.userDetails = $localStorage.userDetails
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .actionKey('F1')
          .position('top right')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              // alert('You clicked the \'UNDO\' action.');
            }
          })
          .catch(() => {})
      }
      $scope.organizationUsers = []
      $scope.organizationExternalUsers = []
      // load organization users
      $scope.load_organizationUsers = function () {
        // alert($scope.organizationId);
        $scope.loading_organizationUsers = true
        var request_json = {
          method: 'GET',
          url: USER_BASEURL + '/organizationUsers/' + $scope.organizationId
        }
        $http(request_json).then(
          function (response) {
            $scope.loading_organizationUsers = false
            if (response.data.status.code == 0) {
              $scope.organizationUsers = response.data.users
            } else {
              $scope.showMessageToast(response.data.status.error)
            }
          },
          function (response) {
            $scope.loading_organizationUsers = false
            handleServerError(response)
          }
        )
      }
      $scope.loadOrganizationExternalUsers = () => {
        // alert($scope.organizationId);
        if (
          !(
            $localStorage.userDetails.permission_role === 'administrator' ||
            $localStorage.isResellerSso
          )
        )
          return
        const requestJson = {
          method: 'GET',
          url: `${V2_BASEURL}/organizations/${$localStorage.currentUserOrganization.id}/external-users`
        }
        $http(requestJson).then(
          response => {
            $scope.organizationExternalUsers = response.data.users
          },
          error => {
            if (error.data && error.data.message) {
              $scope.showMessageToast(error.data.message)
            } else {
              alert('Error occurred.')
            }
          }
        )
      }
      $scope.load_organizationUsers()
      $scope.loadOrganizationExternalUsers()
      // write function for adding a user
      $scope.show_addOrganizationUser = function (ev) {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                organizationId: $scope.organizationId
              }
            },
            controller: 'OrganizationUserAddController',
            // controller: function(){},
            templateUrl:
              './templates/organization.manage.user.add.view.html?t=' +
              window.webpackHash,
            // parent: angular.element(document.getElementById('manage-organization-container')),
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(function (response) {
            $scope.showMessageToast(response.data.status.error)
            $scope.organizationUsers = []
            $scope.load_organizationUsers()
            $scope.loadOrganizationExternalUsers()
            // trackItem_user(response.data.id);
          })
          .catch(function (response) {})
      }
      // write function for adding permissions to a user
      $scope.show_addOrganizationUserAccessPermissions = function (ev) {
        // alert(ev.id)
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                organizationId: $scope.organizationId,
                user_id: ev.id
              }
            },
            controller: 'OrganizationUserAccessPermissionsAddController',
            // controller: function(){},
            templateUrl:
              './templates/organization.manage.useraccesspermissions.add.view.html?t=' +
              window.webpackHash,
            // parent: angular.element(document.getElementById('manage-organization-container')),
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(function (response) {
            $scope.showMessageToast(response.data.status.error)
            trackItem_user(ev.id)
          })
          .catch(function (response) {})
      }
      $scope.makeSuperAdmin = function (user, super_admin) {
        var request_json = {
          method: 'GET',
          url: USER_BASEURL + '/user/' + user.id,
          data: {}
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              var editing_user = response.data.user
              editing_user.organization_permissions.super_admin = super_admin
              var request_json = {
                method: 'PUT',
                url: USER_BASEURL + '/users/' + editing_user.id,
                data: editing_user
              }
              $http(request_json).then(
                function (response) {
                  if (response.data.status.code == 0) {
                    trackItem_user(user.id)
                  } else {
                    $scope.showMessageToast(response.data.status.error)
                  }
                },
                function (response) {
                  handleServerError(response)
                }
              )
            }
          },
          function (response) {
            handleServerError(response)
          }
        )
      }
      $scope.user_forgotPassword = function (ev, email) {
        var request_json = {
          method: 'POST',
          url: USER_BASEURL + '/forgetpassword/' + email,
          data: {}
        }
        $http(request_json).then(
          function (response) {
            // ~ console.log('forgot password response');
            // ~ console.log(response);
            if (response.data.status.code == 0) {
              if (response.data.url != '') {
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .clickOutsideToClose(false)
                    .title($translate('resetPassword'))
                    .textContent(
                      $translate(
                        'anEmailWithInstructionsToResetPasswordHasBeenSentTo '
                      ) +
                        ' ' +
                        email +
                        ''
                    )
                    .ariaLabel($translate('resetPassword'))
                    .ok($translate('ok'))
                    .targetEvent(ev)
                )
              } else {
                var toast = $mdToast
                  .simple()
                  .textContent($translate('unableToGetPasswordResetLink'))
                  .action('ok')
                  .position('top')
                  .hideDelay(5000)
                  .actionKey('F1')

                $mdToast.show(toast).catch(() => {})
              }
            } else {
              var toast = $mdToast
                .simple()
                .textContent(response.data.status.error)
                .action('ok')
                .position('top')
                .actionKey('F1')
                .hideDelay(5000)

              $mdToast.show(toast).catch(() => {})
            }
          },
          function (response) {
            $scope.showMessageToast($translate('errorOccurredPleaseTryAgain'))
          }
        )
      }
      // write function for deleting user
      $scope.confirmUserDelete = function (ev, user) {
        var user_id = user.id
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = $mdDialog
          .confirm()
          .title($translate('AreYouSureYouWantToDeleteThisUser'))
          .textContent('')
          .ariaLabel($translate('deleteUser'))
          .targetEvent(ev)
          .ok($translate('delete'))
          .cancel($translate('cancel'))

        $mdDialog.show(confirm).then(
          function () {
            var request_json = {
              method: 'DELETE',
              url: USER_BASEURL + '/users/' + user.id,
              data: {}
            }
            $http(request_json).then(
              function (response) {
                $scope.showMessageToast(response.data.status.error)
                if (response.data.status.code == 0) {
                  var user_index = -1
                  for (var i = 0; i < $scope.organizationUsers.length; i++) {
                    if ($scope.organizationUsers[i].id == user_id) {
                      user_index = i
                      break
                    }
                  }
                  if (user_index > -1) {
                    $scope.organizationUsers.splice(user_index, 1)
                  }
                }
              },
              function (response) {
                handleServerError(response)
              }
            )
          },
          function () {
            // discard delete.
          }
        )
      }
      $scope.confirmExternalUserDelete = function (ev, user) {
        // Appending dialog to document.body to cover sidenav in docs app
        const confirm = $mdDialog
          .confirm()
          .title($translate('AreYouSureYouWantToDeleteThisUser'))
          .textContent('')
          .ariaLabel($translate('deleteUser'))
          .targetEvent(ev)
          .ok($translate('delete'))
          .cancel($translate('cancel'))

        $mdDialog.show(confirm).then(
          function () {
            const requestJson = {
              method: 'DELETE',
              url: `${V2_BASEURL}/organizations/${$localStorage.currentUserOrganization.id}/external-users`,
              data: {
                email: user.email
              }
            }
            $http(requestJson).then(
              response => {
                $scope.showMessageToast(response.data.status.error)
              },
              response => {
                handleServerError(response)
              }
            )
          },
          function () {
            // discard delete.
          }
        )
      }
      // write function for inviting users to organization

      $scope.hideManageOrganization = function () {
        // This method is implemented in edge.controller.js
        $scope.$emit('controlManageOrganization', {})
        $state.go('home.common.settings')
      }
      function trackItem_user (user_id) {
        var request_json = {
          method: 'GET',
          url: USER_BASEURL + '/user/' + user_id,
          data: $scope.editingOrganization
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              var user_index = -1
              for (var i = 0; i < $scope.organizationUsers.length; i++) {
                if ($scope.organizationUsers[i].id == user_id) {
                  user_index = i
                  break
                }
              }
              if (user_index > -1) {
                $scope.organizationUsers[user_index] = response.data.user
              } else {
                $scope.organizationUsers.push(response.data.user)
              }
            }
          },
          function (response) {
            handleServerError(response)
          }
        )
      }
      function handleServerError (response) {
        if (response && response.data) {
          if (response.data.statusCode == 401) {
            // $state.go('home');
            $scope.$emit('handleServer', {})
          }
        } else {
          $scope.showMessageToast($translate('errorOccurred'))
        }
      }
    }
  ])
